import React, { useState } from "react";
import {
  useTable,
  useGlobalFilter,
  usePagination,
  useSortBy,
} from "react-table";
import { GlobalFilter } from "./GlobalFIlter";
import { useLocation } from "react-router-dom";
import SelectValidator from "./SelectValidator";
import { getUserTypeOptions, stateOption, starblazeMerchantId } from "../../../utils";
import { decrypt } from "../../../utils/encodingdecoding";
import { ValidatorForm } from "react-form-validator-core";
import { getCellAlignProps } from "../../../utils/helper";

const Paginated = ({ columns, data, originalData, setFilteredData, templateList, selectedState, setSelectedState, selectedStatus, setSelectedStatus, selectedProduct, setSelectedProduct, handleSuperonFilter }) => {
  const {
    getTableProps,
    getTableBodyProps,
    rows,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    state,
    gotoPage,
    setPageSize,
    prepareRow,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: ["searchText"],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { globalFilter, pageIndex, pageSize } = state;
  const location = useLocation()
  const Id = localStorage.getItem("Id")
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const options = [
    { label: "Select All", value: "all" },
    ...stateOption
  ];
  const statusOptions = [
    { label: "All Status", value: "" },
    { label: "Active", value: "Active" },
    { label: "InActive", value: "InActive" },
  ];

  const productOptions = [
    { label: "All Products", value: "" },
    ...(templateList || []).map((item) => ({
      label: item?.product_Description,
      value: item?.product_Description,
    })),
  ];

  const handlePageIndex = (event) => {
    if (event.target.value !== "") {
      const number = event.target.value ? Number(event.target.value) - 1 : 0;
      gotoPage(number);
    }
  };

  const handleTemplateFilter = (e) => {
    const value = e.target.value;
    setSelectedTemplate(value);

    if (value === "") {
      setFilteredData(originalData);
    } else {
      const filtered = originalData.filter(
        item => item.productName === value
      );
      setFilteredData(filtered);
    }
  };

  const onSubmit = () => { }

  return (
    <div className="customTable">
      <div className="customTable__header">
        <div className="customTable__left">
          <div className="customTable__showingRecords">
            <div className="form-group">
              <label>Show Records:</label>
              <select
                className="form-control selectArrow"
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
              >
                {[10, 25, 50, 100].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="customTable__right">
          {location.pathname.includes("/channel-partner/orders") && <ValidatorForm onSubmit={onSubmit}>
            <div className="d-flex gap-2 align-items-center">
              <div style={{ minWidth: "220px" }} >
                <SelectValidator
                  placeholder="Select State"
                  className="custom-ReactSelect bordered"
                  name="type"
                  value={options.find((item) => item.value === selectedState)}
                  selected={selectedState}
                  options={options}
                  onChange={(option) => {
                    setSelectedState(option.value);
                  }}
                />
              </div>

            </div>
          </ValidatorForm>}

          {decrypt(Id) === starblazeMerchantId && <>
            <div className="d-flex gap-2 align-items-center">
              <ValidatorForm >
                <div className="d-flex gap-2">
                  <div style={{ minWidth: "220px" }}>
                    <SelectValidator
                      placeholder="Select Product"
                      className="custom-ReactSelect bordered"
                      name="product"
                      value={productOptions.find(
                        (item) => item.value === selectedProduct
                      )}
                      options={productOptions}
                      onChange={(option) => {
                        handleSuperonFilter?.("product", option.value);
                      }}
                    />
                  </div>

                  <div style={{ minWidth: "220px" }}>
                    <SelectValidator
                      placeholder="Select Status"
                      className="custom-ReactSelect bordered"
                      name="status"
                      value={statusOptions.find(
                        (item) => item.value === selectedStatus
                      )}
                      options={statusOptions}
                      onChange={(option) => {
                        handleSuperonFilter?.("status", option.value);
                      }}
                    />
                  </div>

                </div>
              </ValidatorForm>
            </div>
          </>}

          {location.pathname.includes("qrcode-list") && <div className="form-group mt-2" >
            <select
              className="form-control selectArrow"
              value={selectedTemplate}
              onChange={handleTemplateFilter}
            >
              <option value="">Select Product</option>
              {templateList?.map((tpl, index) => (
                <option key={index} value={tpl}>
                  {tpl}
                </option>
              ))}
            </select>
          </div>}
        </div>
      </div>
      <div className="customTable__body">
        <div className="table-responsive">
          <table
            className="table table-striped table-bordered"
            {...getTableProps()}
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            {page?.length ? (
              <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} key={i}>
                      {row.cells.map((cell) => {
                        return (
                          <td {...getCellAlignProps(cell)}>
                            {cell.render("Cell") ? cell.render("Cell") : "Null"}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan={12}>
                    <p style={{ textAlign: "center", margin: 0 }}>
                      No data found
                    </p>
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </div>
      <div className="customTable__footer">
        <div className="customTable__left">
          <div className="customTable__totalTransactions">
            <p>
              Total Records: <span>{rows.length}</span>
            </p>
          </div>
        </div>
        <div className="customTable__right">
          <div className="customTable__top">
            <div className="customTable__totalPages">
              <p>
                Page
                <select
                  className="form-control selectArrow"
                  value={pageIndex + 1}
                  onChange={handlePageIndex}
                >
                  {pageOptions?.length ? (
                    pageOptions.map((pageIndex) => (
                      <option key={pageIndex} value={pageIndex + 1}>
                        {pageIndex + 1}
                      </option>
                    ))
                  ) : (
                    <option key={1} value={1}>
                      {1}
                    </option>
                  )}
                </select>
                of <span>{pageOptions.length ? pageOptions.length : 1}</span>
              </p>
            </div>
          </div>
          <div className="customTable__bottom customTable__bottom__2">
            <div className="customTable__buttons">
              <span
                className="btn btn-outline-primary"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                {"Previous"}
              </span>
              <span
                className="btn btn-outline-primary"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                {"Next"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Paginated;
